import PriceChange from './PriceChange.js';
import PricePerTime from './PricePerTime.js';

export default class PriceHistory {
    constructor(basePrice, priceChanges) {
        this.basePrice = basePrice;
        this.priceChanges = priceChanges;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const priceHistory = new PriceHistory();
        priceHistory.basePrice = PricePerTime.fromData(data.basePrice.data);
        priceHistory.priceChanges = data.priceChanges.data.map((priceChange) => new PriceChange(priceChange.start, PricePerTime.fromData(priceChange.price.data)));

        Object.seal(priceHistory);
        return priceHistory;
    }

    getCurrentPricePerTime() {
        let maxValidTime = null;
        let currentPriceChange = null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        this.priceChanges.forEach((priceChange) => {
            const compareDate = new Date(priceChange.start);
            compareDate.setHours(0, 0, 0, 0);
            const compareTime = compareDate.getTime();
            if (compareTime <= today.getTime()) {
                if (maxValidTime === null || maxValidTime < compareTime) {
                    currentPriceChange = priceChange;
                    maxValidTime = compareTime;
                }
            }
        });

        return currentPriceChange !== null ? currentPriceChange.pricePerTime : this.basePrice;
    }

    getUpcomingPriceChange() {
        let minValidTime = null;
        let upcomingPriceChange = null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        this.priceChanges.forEach((priceChange) => {
            const compareDate = new Date(priceChange.start);
            compareDate.setHours(0, 0, 0, 0);
            const compareTime = compareDate.getTime();
            if (compareTime > today.getTime()) {
                if (minValidTime === null || minValidTime > compareTime) {
                    upcomingPriceChange = priceChange;
                    minValidTime = compareTime;
                }
            }
        });

        return upcomingPriceChange;
    }

    toData() {
        return {
            basePrice: this.basePrice.toData(),
            priceChanges: this.priceChanges.map((priceChange) => priceChange.toData()),
        };
    }

    clone() {
        return new PriceHistory(this.basePrice.clone(), this.priceChanges.map((priceChange) => priceChange.clone()));
    }
}
